export default __webpack_public_path__ + "static/media/pageInDevelopment.c361dbde.svg";